<h1 mat-dialog-title></h1>
<div mat-dialog-content>
    <div class="confirm-message">
        Are you sure you want to delete all non Mef entities?
    </div>
  
</div>
<div mat-dialog-actions>
    <div class="a-modal-footer modal-footer pad-zero" style="float: right; display: flex; justify-content: flex-end; width: 100%;">
        <ap-button [label]="'CANCEL'" class="ap-mr-spacing-3" [btnType]="'primary'"
            (onClick)="cancel()"></ap-button>
        <ap-button [btnType]="'primary'" [label]="'MEF SYNC DELETE'" class="ap-mr-spacing-3"
        (onClick)="sync('MEF_SYNC_DELETE')"></ap-button>

    </div>
  
</div>